import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { deleteEquipo, getEquipos } from "../../../services";
import { Link } from "react-router-dom";
import Add from "../../../icons/add.svg";
import Delete from "../../../icons/delete.svg";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { UsuarioContext } from "../../../providers/userContext";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { Box } from "@mui/material";
import { DataTable } from "../../../components";
import Editar from "../../../icons/editar.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros } from "../../../functions/parametrosURL/funcionesParamsURL";

const Equipos = () => {
  const { t } = useTranslation('common');


  const urlPadre = window.location.pathname;
  const navigate = useNavigate();

  const user = useContext(UsuarioContext)
  const [equipos, setEquipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  // useEffect(() => {
  //   fetchData()
  // }, [recargar]);

  const fetchData = async ({ offset, limit, filtros = {} } = {}) => {
    
    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros);
    
    const payload = {
      filtros,
      params: { page: offset, limit },
    };
    try {
      setLoading(true);
      const response = await getEquipos(payload);
      const { meta, data } = response;
      setEquipos(data)
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const formatData = (data) => {
    return data.map((row, i) => ({
      id: row.id,
      equipo: row.nombre,
      numTec: (row.technician?.length || 0)?.toString()
    }));
  };

  const equiposRows = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "",
    },
    {
      id: "equipo",
      numeric: false,
      disablePadding: false,
      label: t('teams.columns.team'),
    },
    {
      id: "numTec",
      numeric: false,
      disablePadding: false,
      label: t('teams.columns.numTechnicians'),
    },
    user.rol === 'ADMIN' ?
    {
      id: "eliminar",
      numeric: false,
      disablePadding: false,
      label: "",
      style: { width: "fit-content", textAlign: "right" },
      overrideFunc: (data, row) => (
        <>
          <Link to = {`/equipos/editar/${row.id}`}>
            <img
              src={Editar}
              alt="EDITAR"
              className="tableIcon"
            ></img>
          </Link>
          <img
            src={Delete}
            alt="ELIMINAR"
            className="tableIcon"
            onClick={() => eliminarEquipo(row)}
          ></img>
        </>
      )
    }
    : '',
  ]

  const eliminarEquipo = (com) => {
    if(parseInt(com.numTec) > 0){
      toast.error(t('teams.messages.hasTechnicians'));
    }else{
      Swal.fire({
        title: t('teams.messages.confirmDelete'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: t('actions.cancel'),
        confirmButtonText: t('messages.yesDelete'),
      })
        .then((result) => {
          if (result.isConfirmed) {
            deleteEquipo(com.id)
              .then((res) => {

                if (res.message === "TEAM_DELETED") {
                  toast.success(t('teams.messages.deleted'));
                  setRecargar(!recargar);

                } else {
                  toast.error(t('teams.messages.deleteError'));
                }
              })
              .catch((e) => {
                toast.error(t('teams.messages.deleteError'));
                console.log(e);
              });
          }
        })
        .catch((e) => {
          toast.error(t('messages.error'));
          console.log(e);
        });
    }
  };


  return (
    <>
      <BreadCrumb rutas={[{path:`/tecnicos`, label: t('technicians.title')}, {path:`/equipos`, label: t('teams.title')}]} />
      <div className="listPage">
        <div className="gridCard">
            <div className="gridHead">
                {t('teams.title').toUpperCase()}
            </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <div className="contentBar">
          <div></div>
          {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol !== "VENT") &&
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'end'}}>
              <Link to="/equipos/nuevo-equipo">
                <div className="contentButton mx-2">
                  <img src={Add} alt={t('teams.new')} />              
                </div>
              </Link>
            </div>
          }
        </div>
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={equiposRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                // filtros={busqueda}
                recargar={recargar}
                mensaje={t('teams.messages.noTeams')}
              />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default Equipos;
